import { useAtom } from 'jotai';
import React, { useEffect } from 'react';
import { languageAtom } from '../shared/Atom.language';
import { createLanguage } from '../Adapters/createLanguage';

const useLogic = () => {
  const [lang] = useAtom(languageAtom);

  console.log('lang is =>', lang);

  const HandleCreateLanguage = (language) => {
    console.log('language created');
    if (language !== 'fa-IR') {
      createLanguage(lang);
    }
  };
  useEffect(() => {
    if (!Array.isArray(lang)) HandleCreateLanguage(lang);
  }, [lang]);
};

export default useLogic;
